<template>
      <div>
            <!-- headline Slot -->
            <slot name="headline"></slot>

            <!-- Body -->
            <j-card v-if="!isLoading" class="bg5">
                  <!-- If Expendable is False, show list version -->
                  <j-list v-if="!isExpandable" :list="computedListing">
                        <div class="flex xs-12 p3" slot="list" slot-scope="{ item }">
                              <div class="flex xs-6 xs-left xs-middle fw7 c6">{{ item.id }}</div>
                              <!-- If id is passed , name will be turned into link -->
                              <div v-if="item.id === $t('name')" class="flex xs-6 xs-left xs-middle">
                                    <router-link v-if="hasLink" :to="computedLink">
                                          {{
                                          item.value
                                          }}
                                    </router-link>
                                    <div v-else>{{ item.value }}</div>
                              </div>
                              <!-- Else -->
                              <div v-else class="flex xs-6 xs-left xs-middle">{{ item.value }}</div>
                        </div>
                  </j-list>

                  <!-- If Expendable is True, show expendable box version -->
                  <j-expendable-box v-if="isExpandable">
                        <!-- Return name of individual as header for expendable box -->
                        <div slot="header" class="p3 fs3 fw7 c2">{{ this.computedListing[0].value }}</div>
                        <div slot="body">
                              <j-list :list="computedListing">
                                    <div class="flex xs-12 p3" slot="list" slot-scope="{ item }">
                                          <div class="flex xs-6 xs-left xs-middle fw7 c6">{{ item.id }}</div>
                                          <div class="flex xs-6 xs-left xs-middle">{{ item.value }}</div>
                                    </div>
                              </j-list>
                        </div>
                  </j-expendable-box>
            </j-card>

            <!-- Loading -->
            <j-spinner v-if="isLoading"/>

            <!-- Footer Slot -->
            <slot name="footer"></slot>
      </div>
</template>

<script>
import JCard from "@/components/JCard/"
import JList from "@/components/JList/"
import JExpendableBox from "@/components/JExpendableBox"
import JSpinner from "@/components/JSpinner"
import dayjs from "dayjs"

export default {
	components: {
		JCard,
		JList,
		JExpendableBox,
		JSpinner
	},

	props: {
		id: String,
		name: String,
		natureOfBusiness: String,
		registrationNumber: String,

		isExpandable: {
			type: Boolean,
			default: false
		},

		// If true , will create link to client/overview
		hasLink: {
			type: Boolean,
			default: false
		},

		isLoading: {
			type: Boolean,
			default: false
		}
	},

	computed: {
		// Map props to computedListing Array
		computedListing() {
			return [
				{ id: this.$t("name"), value: this.name },
				{
					id: this.$t("nature_of_business"),
					value: this.natureOfBusiness
				},
				{
					id: this.$t("registration_number"),
					value: this.registrationNumber
				}
			]
		},

		// Link to client overview
		computedLink() {
			return `/${this.$store.state.tenantId}/clients/detail/${
				this.id
			}/overview/company`
		}
	}
}
</script>
